import 'rxjs/Rx';
import {Component, EventEmitter, OnDestroy, Output} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {
    AlertMessage,
    AlertService,
    AppStateService,
    LoggerService,
    ModalService,
    PollUtilService,
    WebUtilService
} from '../../hbs-services';

@Component({
    selector: 'poll-alert',
    moduleId: module.id,
    templateUrl: './alert.component.html'
})
export class AlertComponent implements OnDestroy {

    // output action from AlertComponent to containing component
    @Output() actionEvent = new EventEmitter(true);

    alert: AlertMessage;
    subscription: any;
    dismissed: boolean = false;

    // extra custom fields
    loginUrl: SafeUrl;

    constructor(private alertService: AlertService,
                private appStateService: AppStateService,
                private pollUtilService: PollUtilService,
                private webUtilService: WebUtilService,
                private modalService: ModalService,
                private domSanitizer: DomSanitizer,
                private logger: LoggerService) {
        this.subscription = alertService.subscribe((alert: AlertMessage) => this.setMessage(alert));
    }

    setMessage(alert: AlertMessage) {
        this.logger.log('AlertComponent: alert', alert);
        this.alert = alert;
        this.webUtilService.scrollTop();
        this.loginUrl = null;

        if (alert && (alert.code === 403/*Access Denied*/ || alert.code === 0/*not logged in (CAS)*/)) {

            const currentUrl = this.webUtilService.getCurrentUrl();

            const configResponse = this.appStateService.getConfig();
            const userRelatedData = this.pollUtilService.calcUserRelatedData(configResponse);

            if (!userRelatedData.isSignedUser) {
                this.loginUrl = this.domSanitizer.bypassSecurityTrustUrl(userRelatedData.loginUrl + currentUrl);
            }
            this.logger.log('AlertComponent:', 'userRelatedData:', userRelatedData, 'this.loginUrl:', this.loginUrl);
        }
    }

    dismiss() {
        this.dismissed = !this.dismissed;
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    action(type: string): boolean {
        this.actionEvent.emit(type);
        return false;
    }

}
